"use strict";

exports.__esModule = true;
exports.CSSBaseline = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledSystem = require("@manifest-ui/styled-system");

var _react2 = require("@emotion/react");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/css-baseline/src/CSSBaseline.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const CSSBaseline = () => React.createElement(_react2.Global, {
  styles: theme => (0, _styledSystem.css)({
    '*, *:before, *:after': {
      boxSizing: 'border-box',
      textRendering: 'geometricPrecision',
      WebkitTapHighlightColor: 'transparent'
    },
    html: {
      fontSize: 'medium'
    },
    body: {
      fontFamily: 'body',
      fontSize: 'medium',
      letterSpacing: 'normal',
      lineHeight: 'large',
      margin: 0,
      minHeight: '100%',
      overflowX: 'hidden',
      padding: 0,
      position: 'relative',
      textRendering: 'optimizeLegibility',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    },
    'html, body': {
      backgroundColor: 'background.body',
      color: 'emphasis.primary'
    },
    'strong, b': {
      fontWeight: 'bold'
    }
  })(theme),
  __self: void 0,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 6,
    columnNumber: 3
  }
});

exports.CSSBaseline = CSSBaseline;